import { render } from "./TopdestinationCom.vue?vue&type=template&id=08316f82&scoped=true"
import script from "./TopdestinationCom.vue?vue&type=script&lang=js"
export * from "./TopdestinationCom.vue?vue&type=script&lang=js"

import "./TopdestinationCom.vue?vue&type=style&index=0&id=08316f82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08316f82"]])

export default __exports__